import React from "react";
import { useSummary } from "../../lib/varSummary";
import { useFilter } from "../../lib/varFilter";
import { useHeader } from "../../lib/varHeader";


const SearchMeta = () => {
    const { summary } = useSummary();
    const { filter } = useFilter();
    const { header } = useHeader();
    let pageSize
    filter.page_size ? pageSize = filter.page_size : pageSize = 20
    return (
        <div className="main">
            <ul>
                <li key={'totSongs'} title='Total number of songs in the database (including delisted)'>Total Songs in database (including delisted): {summary.totalSongs}</li>
                <li key={'available'} title='This number excludes songs that have been delisted for various reasons'>Playable Songs: {summary.availableSongs}</li>
                <li key={'found'} title='Songs found with current search pattern'>Total Songs Found: {summary.totalFound}</li>
                {header.current_loaded_page && summary.totalFound ? <li key={'displayed'} title='Songs viewed in display'>Showing: {((header.current_loaded_page - 1) * pageSize)+1} - {Math.min((header.current_loaded_page * pageSize), summary.totalFound)}</li> : null}
                <li key={'totArtist'} title='Total number of artists listed'>Total Artists: {summary.totalArtists}</li>
                <li key={'totAlbum'} title='Total number of albums listed'>Total Albums: {summary.totalAlbums}</li>
                <li key={'totArr'} title='Total number of arrangements, AI and Authentic'>Total Arrangements: {summary.totalArrangements}</li>
                <ul>
                    <li key={'ARCHI'} title='ARCHI - AI created arrangements'>Total AI Arrangements: {summary.AIArrangements}</li>
                    <li key={'AuthArr'} title='Authentic playable arrangemtns'>Total Authentic Arrangements: {summary.AuthArrangements}</li>
                    { summary.arrangements ?
                        Object.keys(summary.arrangements).map((i, j) => (
                            <li key={i} title={i}>{i.replace('_', ' ').replace('ai ', 'AI ')}: {summary.arrangements[i]}</li>
                        ))
                    : null }
                </ul>
            </ul>
        </div>
    )
}

export default SearchMeta